import { ProductDataSchema } from "@redotech/redo-return-operations-common/customer-portal/product";
import * as z from "zod";

const RecommendedOptionSchema_ = z.object({
  optionName: z.string(),
  optionValue: z.string(),
});
export const RecommendedOptionSchema: z.ZodType<RecommendedOption> =
  RecommendedOptionSchema_;
export interface RecommendedOption extends z.infer<
  typeof RecommendedOptionSchema_
> {}

const RankedProductOutputSchema_ = z.object({
  product: ProductDataSchema,
  recommendedOptions: z.array(RecommendedOptionSchema).optional(),
  /**
   * Which candidate category this product came from, e.g. "similar" or
   * "popular". Not customer-facing copy — callers map it to their own wording.
   */
  source: z.string().optional(),
});
export const RankedProductOutputSchema: z.ZodType<RankedProductOutput> =
  RankedProductOutputSchema_;
export interface RankedProductOutput extends z.infer<
  typeof RankedProductOutputSchema_
> {}

const RecommendationOutputSchema_ = z.object({
  product: ProductDataSchema,
  explanation: z.string(),
  subtitle: z.string().optional(),
  recommendedOptions: z.array(RecommendedOptionSchema).optional(),
  rankedProducts: z.array(RankedProductOutputSchema).optional(),
});
export const RecommendationOutputSchema: z.ZodType<RecommendationOutput> =
  RecommendationOutputSchema_;
export interface RecommendationOutput extends z.infer<
  typeof RecommendationOutputSchema_
> {}

const AdvancedExchangeRecommendationOutputSchema_ = z.object({
  recommendation: RecommendationOutputSchema.optional(),
  noRecommendationReason: z.string().optional(),
});
export const AdvancedExchangeRecommendationOutputSchema: z.ZodType<AdvancedExchangeRecommendationOutput> =
  AdvancedExchangeRecommendationOutputSchema_;
export interface AdvancedExchangeRecommendationOutput extends z.infer<
  typeof AdvancedExchangeRecommendationOutputSchema_
> {}
